import { ShareData } from '../models/share.model';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
@Injectable()
export class SocialMediaService {
  private readonly additionalHeaders =  new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {}

  getSocialMediaUrl(shareData: ShareData, socialMedia: string): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/${socialMedia}`, JSON.stringify(shareData), {headers: this.additionalHeaders})
    .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/social-media.service.ts